export default __webpack_public_path__ + "static/media/venture-dark.bc4f3fe6.svg";